import { fromEmpty } from 'maybeasy';
import { observer } from 'mobx-react';
import * as React from 'react';
import NoParticipants from '../../../../../../../../../../../DeepLinks/DeepLinksBody/InviteParticipantModal/RenderInviteParticipantsModal/ReadyModal/Body/ParticipantsList/NoParticipants';
import InviteParticipantStore from '../../../../Store';
import { SelectParticipantsState } from '../../../../Store/Types';
import Participants from './Participants';

export interface Props {
  store: InviteParticipantStore;
  state: SelectParticipantsState;
}

const ParticipantsList: React.FC<Props> = ({ store, state }) =>
  fromEmpty([...state.newGroupsAndParticipants])
    .map(() => <Participants store={store} state={state} />)
    .getOrElse(() => <NoParticipants submit={store.submit} />);

export default observer(ParticipantsList);
